import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isGuestRole } from "../../redux/slices/users";
import SelectorIntraverseLogoIcon from "../../assets/images/logos/HeroLogoIntraverse.png";
import BackgroundVideo from "../../assets/videos/v1_splashart_anim_EDM_v1.mp4";
import { ReactComponent as SystemIcon } from "../../assets/images/icons/System.svg";
import Button from "../../components/common/button/Button";
import { getDeviceOrientation } from "../../utils/generalUtils";
import { setColor } from "../../assets/styles/styles";
import Typography from "../../components/common/text/Typography";
import { sendVerificationEmail, Logout } from "../../api/UserController";

const GuestToUser = () => {
    const navigate = useNavigate();
    const checkGuestRole = useSelector(isGuestRole);
    const user = useSelector((state) => state.user);
    const [orientation, setOrientation] = useState(getDeviceOrientation());

    const handleCompleteAccount = async () => {
        await sendVerificationEmail(user.userId, user.token);
        navigate("/verify-email");
    };

    const callLogoutandClear = async () => {
        await Logout();
    };

    return (
        <MainContainer orientation={orientation}>
            <VideoBackground src={BackgroundVideo} playsInline controls={false} autoPlay loop muted />
            <Overlay />
            <TopLeft>
                <Button
                    variant={"PurpleArrowButton"}
                    label={"Logout"}
                    letterSpacing={"normal"}
                    fontSize={"12px"}
                    padding={"12px"}
                    minHeight={"0px"}
                    onClick={callLogoutandClear}
                />
            </TopLeft>
            <StyledImage src={SelectorIntraverseLogoIcon} alt="Intraverse Logo" />
            <Box>
                <StyledSystemIcon />
                You're currently playing as a guest. Create a full account to save your progress and unlock more
                features!
            </Box>

            <Button
                margin={"30px 0px"}
                label="Complete Account"
                variant="PurpleButton"
                onClick={handleCompleteAccount}
            />
            <Footer>
                <Typography
                    variant="p"
                    style={{
                        color: "var(--iconColor)",
                        fontSize: "12px",
                    }}
                >
                    ©{new Date().getFullYear()} TerraZero Technologies. All rights reserved.
                </Typography>
            </Footer>
        </MainContainer>
    );
};

export default GuestToUser;

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 5;
    height: 100%;
    width: 100%;

    ${(props) => {
        if (props.orientation && props.orientation === "portrait") {
            return `
        padding: 25px;
        transform: rotate(-90deg);
        height:100vw;
        width: 100vh;
      `;
        }
        return `
        transform: none;
        padding: none;
        height: 100%;
        width: 100%;
      `;
    }}
`;

const StyledImage = styled.img`
    width: 700px;
    height: auto;

    @media (max-width: 1440px) {
        width: 600px;
    }

    @media (max-width: 1024px) {
        width: 380px;
    }

    @media (max-width: 768px) {
        width: 280px;
    }

    @media (max-width: 480px) {
        width: 200px;
    }
`;

const VideoBackground = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    filter: brightness(0.9) contrast(1.05) saturate(1.1);
    z-index: -2;
    pointer-events: none;

    @media (max-aspect-ratio: 16/9) {
        object-fit: contain;
        background: black;
    }
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8));
    z-index: -1;
`;

const Content = styled.div`
    padding: 0;
`;

const Box = styled.div`
    width: 650px;
    height: 60px;
    border-radius: 5px;
    background-color: #736a22e5;
    color: #ffe664;
    align-items: center;
    justify-content: center;
    display: flex;
    font-family: Barlow;
    font-size: 16px;
    font-weight: 700;
    padding: 20px;
    font-style: normal;
    line-height: 18px;

    @media (max-width: 1440px) {
        width: 550px;
        font-size: 15px;
        padding: 30px;
    }

    @media (max-width: 1024px) {
        width: 450px;
        font-size: 14px;
        padding: 20px;
    }

    @media (max-width: 768px) {
        width: 450px;
        font-size: 12px;
        padding: 20px;
    }

    @media (max-width: 480px) {
        width: 450px;
        font-size: 12px;
        padding: 20px;
    }
`;

const StyledSystemIcon = styled(SystemIcon)`
    width: 20px;
    height: 20px;
    margin-top: -20px;
`;

const TopLeft = styled.div`
    position: absolute;
    top: 20px; /* distance from top */
    left: 20px; /* distance from left */
    z-index: 2;
`;

const Footer = styled.div`
    position: absolute;
    bottom: 20px; /* distance from bottom */
    right: 20px; /* distance from right */
    z-index: 2;

    @media (max-width: 768px) {
        bottom: 10px;
        right: 10px;
    }
`;
